export const services = [
  {
    title: 'React',
    imgSrc: 'https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg',
  },
  {
    title: 'Next JS',
    imgSrc: 'https://www.vectorlogo.zone/logos/nextjs/nextjs-icon.svg',
  },
  {
    title: 'Node.js',
    imgSrc: 'https://www.vectorlogo.zone/logos/nodejs/nodejs-icon.svg',
  },
  {
    title: 'JavaScript',
    imgSrc: 'https://cdn.worldvectorlogo.com/logos/javascript-1.svg',
  },
  {
    title: 'Python',
    imgSrc: 'https://www.vectorlogo.zone/logos/python/python-icon.svg',
  },
  {
    title: 'C',
    imgSrc: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg',
  },
  {
    title: 'Tailwind',
    imgSrc: 'https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg',
  },
  {
    title: 'Flask',
    imgSrc: 'https://www.vectorlogo.zone/logos/palletsprojects_flask/palletsprojects_flask-official~v2.svg',
  },
  {
    title: 'MySQL',
    imgSrc: 'https://www.vectorlogo.zone/logos/mysql/mysql-icon.svg',
  },
  {
    title: 'Linux',
    imgSrc: 'https://www.vectorlogo.zone/logos/linux/linux-icon.svg',
  },
  {
    title: 'Git',
    imgSrc: 'https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg',
  },
  {
    title: 'HTML5',
    imgSrc: 'https://www.vectorlogo.zone/logos/w3_html5/w3_html5-icon.svg',
  },
];
